import { IReqClientUserPayload } from '../../features/feature-client-setup/client-user-setup/landing-client-user-setup/useClientUserSetup'
import axiosInstance from '../utils/api-util/utilApi'

const config = { baseURL: process.env.REACT_APP_CLIENT_SETUP_SERVICE_URL || '' }

export const getClientUserList = (payload: IReqClientUserPayload) => {
  return axiosInstance.post(`/api/clientUsers/filter`, JSON.stringify(payload), config)
}

export const postAddClientUser = (payload: any) => {
  return axiosInstance.post(`/api/clientUsers/create`, JSON.stringify(payload), config)
}

export const getClientDetailById = (clientUserId: any, includeUserRole?: boolean, considerActivationDate?: boolean) => {
  const queryParams = new URLSearchParams()

  if (includeUserRole !== undefined) {
    queryParams.append('includeUserRole', String(includeUserRole))
  }

  if (considerActivationDate !== undefined) {
    queryParams.append('considerActivationDate', String(considerActivationDate))
  }

  const queryString = queryParams.toString()
  let url = '/api/clientUsers/' + clientUserId

  if (queryString) {
    url += '?' + queryString
  }

  return axiosInstance.get(url, config)
}

export const putUpdateClientUser = (clientUserId: string, payload: any) => {
  return axiosInstance.put(`/api/clientUsers/update/${clientUserId}`, JSON.stringify(payload), config)
}

export const getUserRoleListByType = (priGrpTypCodeName: string): Promise<any> => {
  return axiosInstance.get(`/api/clientUsers/GetUserRoles/${priGrpTypCodeName}`, config)
}

export const getClientList = () => {
  return axiosInstance.get(`/api/clients/listClientName`, config)
}
